function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    const value = parseInt(this.input.value)
    this.validateQtyRules();
    if(this.closest('form')){
      if(this.closest('form').querySelector('.shop-now-custom')) {
        var id= this.closest('form').querySelector('[name="id"]').value;
        var cart = '/cart/'+id+':'+value+'';
        this.closest('form').querySelector('.shop-now-custom a').setAttribute("href", cart);
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class Accordian extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('.main-accordian a').forEach((accordian) =>
      accordian.addEventListener('click', this.onAccordianClick.bind(this))
    );
    this.querySelectorAll('.desc-question a').forEach((faq) =>
      faq.addEventListener('click', this.onFaqClick.bind(this))
    );
    this.querySelectorAll('a.arrow-down-desc').forEach((description) =>
      description.addEventListener('click', this.onArrowClick.bind(this))
    );
  }

  onAccordianClick(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    // if(__this.classList.contains('active')){
    //   __this.classList.remove('active');
    //   __this.parentNode.classList.remove('nav-active');
    // } else {
      __this.classList.toggle('active');
      __this.parentNode.classList.toggle('nav-active');
    // }
  }
  onFaqClick(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    __this.closest('.main-qna-of-page').classList.toggle('active');
  }
  onArrowClick(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    __this.closest('.amz-product-info-parts').querySelector('.product-description').classList.toggle('active');
  }
}
customElements.define('accordian-toggle', Accordian);

class ProductPopUp extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('.add-to-cart-popup').forEach((popup) =>
      popup.addEventListener('click', this.onClickPopupOpen.bind(this))
    );
    this.querySelectorAll('.close-modal').forEach((button) =>
      button.addEventListener('click', this.onClickPopupClose.bind(this))
    );
  }

  onClickPopupOpen(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    if(__this.closest('body').querySelector('.chat-bot-main-section') != null){
     __this.closest('body').querySelector('.chat-bot-main-section').querySelector('.main-product-chatbot').classList.remove('open');  
     __this.closest('body').querySelector('.product-chatbot-icon').style.zIndex  = '-1';
    }
    var popup_open = __this.getAttribute('data-title');
    var popup_content = document.querySelectorAll('.jquery-modal');
    const matching_popup = document.querySelector(`[product-name="${popup_open}"]`);
    popup_content.forEach((element) => {
      element.classList.remove('open');
    });
    matching_popup.classList.add('open');
    document.body.classList.add('overflow-hidden');
  }

  onClickPopupClose(event) {
    event.preventDefault();
    if(event.currentTarget.closest('body').querySelector('.product-chatbot-icon') != null){
     event.currentTarget.closest('body').querySelector('.product-chatbot-icon').style.zIndex  = 'unset';
    }
    var popup_content = document.querySelectorAll('.jquery-modal');
    popup_content.forEach((element) => {
      element.classList.remove('open');
    });
    document.body.classList.remove('overflow-hidden');
  }
}
customElements.define('product-popup', ProductPopUp);

class ProductInputSelect extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('.outer-subscription-part input').forEach((outer_input) =>
      outer_input.addEventListener('change', this.onClickSelectProduct.bind(this))
    );
    this.querySelectorAll('.input-select-subscription input').forEach((popup_input) =>
      popup_input.addEventListener('change', this.onClickSelectSubscription.bind(this))
    );
    this.querySelectorAll('.input-select-onetime input').forEach((onetime_popup_input) =>
      onetime_popup_input.addEventListener('change', this.onClickSelectOnetime.bind(this))
    );
    this.querySelectorAll('.one-time-and-sub-option input').forEach((select_product) =>
      select_product.addEventListener('change', this.onClickSelectType.bind(this))
    );
    this.querySelectorAll('.combine_popup-button a').forEach((combine_outer_select_combo) =>
      combine_outer_select_combo.addEventListener('click', this.onClickSelectProductType.bind(this))
    );
    this.querySelectorAll('.subscribe-product-list input').forEach((combine_sub_pro_select) =>
      combine_sub_pro_select.addEventListener('change', this.onClickSelectcombineSub.bind(this))
    );
    this.querySelectorAll('.onetime-product-list input').forEach((combine_onetime_pro_select) =>
      combine_onetime_pro_select.addEventListener('change', this.onClickSelectcombineOnetime.bind(this))
    );
  }

  onClickSelectProduct(event) {
    var __this = event.currentTarget;
    var val = __this.getAttribute('value');
    var pro_id = __this.getAttribute('product-id');
    var onetime_ele = __this.closest('.product-column').getElementsByClassName('onetime-form')[0];
    var subscription_ele = __this.closest('.product-column').getElementsByClassName('subscription-popup')[0];
    if(val == "onetime") {
      onetime_ele.classList.remove('hide');
      subscription_ele.classList.add('hide');
    } else if (val == "subscription") {
      onetime_ele.classList.add('hide');
      subscription_ele.classList.remove('hide');
    }
    __this.closest('.outer-subscription-part').getElementsByClassName('active')[0].classList.remove('active');
    __this.parentNode.classList.add('active');
  }

  onClickSelectSubscription(event) {
    var __this = event.currentTarget;
    var pro_id = __this.getAttribute('product-id');
    var popup_inputs = __this.closest('.popup-right-content').getElementsByClassName('select-product');
    var popup_both_inputs = __this.closest('.popup-right-content').getElementsByClassName('purchase-option');
    for (var i = 0; i < popup_both_inputs.length; i++) {
      popup_both_inputs[i].classList.remove('active');
    }
    for (var i = 0; i < popup_inputs.length; i++) {
      popup_inputs[i].classList.remove('active');
    }
    __this.parentNode.classList.add('active');
    // popup form
    var subscription_popup_form = __this.closest('.popup-radio-select-product').getElementsByClassName('subscription-form');
    for (var i = 0; i < subscription_popup_form.length; i++) {
      subscription_popup_form[i].classList.remove('show');
    }
    __this.closest('.popup-radio-select-product').querySelector(`[data-id="${pro_id}"]`).classList.add('show');
  }
  
  onClickSelectOnetime(event) {
    var __this = event.currentTarget;
    var variant_id = __this.getAttribute('variant-id');
    
    var popup_onetime_inputs = __this.closest('.popup-right-content').getElementsByClassName('select-onetime');
    for (var i = 0; i < popup_onetime_inputs.length; i++) {
      popup_onetime_inputs[i].classList.remove('active');
    }
    __this.parentNode.classList.add('active');
    // popup form
    var onetime_popup_form = __this.closest('.popup-radio-select-product').getElementsByClassName('ontime-form');
    for (var i = 0; i < onetime_popup_form.length; i++) {
      onetime_popup_form[i].classList.remove('show');
    }
    __this.closest('.popup-radio-select-product').querySelector(`[data-pro_id="${variant_id}"]`).classList.add('show');
    
    // price change ontime sezzle and afterpay
    var price = __this.closest('.select-onetime').querySelector('.regular-price').innerText;
    price = price.replace("$","");
    var final_price = (price / 4);
    __this.closest('.type-onetime').querySelector('.after-pay-price').innerHTML = '$'+final_price;
  }
  
  onClickSelectType(event) {
    var __this = event.currentTarget;
    var val = __this.value;
    var closest_div = __this.closest('.product-with-sub-products');
    if( val == 'subscription' ) {
      closest_div.querySelector(".subscription-button").style.display = 'block';
      closest_div.querySelector(".onetime-button").style.display = 'none';
    } else {
      closest_div.querySelector(".subscription-button").style.display = 'none';
      closest_div.querySelector(".onetime-button").style.display = 'block';
    }
  }
  
  onClickSelectProductType(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    var val = __this.value;
    var data_type = __this.getAttribute('data-type');
    var outer_select_option = __this.closest('.combine_popup-body').querySelectorAll('.combine_popup-button a');
    for (var i = 0; i < outer_select_option.length; i++) {
      outer_select_option[i].classList.remove('active-tab');
    }
    __this.classList.add('active-tab');
    var product_type_Select = __this.closest('.combine_popup').querySelectorAll('.combine_popup-product');
    for (var i = 0; i < product_type_Select.length; i++) {
      product_type_Select[i].style.display = 'none';
    }
    __this.closest('.combine_popup-body').querySelectorAll(`[data-type1="${data_type}"]`)[0].style.display = 'block';
  }

  onClickSelectcombineSub(event) {
    var __this = event.currentTarget;
    var pro_id = __this.getAttribute('product-id');
    var total_vari_price = __this.getAttribute('product-price');
    
    // popup form
    var subscription_popup_form2 = __this.closest('.subscribe-product-info').getElementsByClassName('subscription-form');
    for (var i = 0; i < subscription_popup_form2.length; i++) {
      subscription_popup_form2[i].classList.remove('show');
    }
    __this.closest('.subscribe-product-info').querySelector(`[data-pro-id="${pro_id}"]`).classList.add('show');
    __this.closest('.subscribe-product-info').querySelector('.update-subscribe-total-price').innerHTML = total_vari_price;
    
    // input_select
    var popup_inputs = __this.closest('.subscribe-product-list').getElementsByClassName('select-product-item');
    for (var i = 0; i < popup_inputs.length; i++) {
      popup_inputs[i].classList.remove('active');
    }
    __this.parentNode.classList.add('active');
  }
  onClickSelectcombineOnetime(event) {
    var __this = event.currentTarget;
    var var_id = __this.getAttribute('product-id')
    var total_price = __this.closest('.select-product-item').querySelector('.product-price').innerText;
    var price = total_price.replace("$","") / 4;
    __this.closest('.onetime-product-info').querySelector('.after-pay-price').innerHTML = '$'+price;
    __this.closest('.onetime-product-info').querySelector('.update-onetime-total-price').innerHTML = total_price;
    // popup form
    var onetime_popup_form2 = __this.closest('.onetime-product-info').getElementsByClassName('ontime-form');
    for (var i = 0; i < onetime_popup_form2.length; i++) {
      onetime_popup_form2[i].classList.remove('show');
    }
    
    if(__this.closest('.onetime-product-info').querySelector(`[data-pro-id="${var_id}"]`) != null){
      __this.closest('.onetime-product-info').querySelector(`[data-pro-id="${var_id}"]`).classList.add('show');
    }else{
      var onetime_select_option = __this.closest('.onetime-product-info').querySelector('.product-onetime-form').querySelector('select');
      for(var j=0;j<onetime_select_option.length;j++){
        if(onetime_select_option[j].getAttribute('productid') == var_id){
          onetime_select_option[j].selected = "true";
        }
      }
    }
    
    // input_select
    var popup_inputs2 = __this.closest('.onetime-product-info').getElementsByClassName('select-product-item');
 
    for (var i = 0; i < popup_inputs2.length; i++) {
      popup_inputs2[i].classList.remove('active');
    }
    __this.parentNode.classList.add('active');
  }
  
}
customElements.define('product-section-input', ProductInputSelect);

function createWidgetByCustomcode (interValName){
  document.querySelectorAll('form.product-single__form').forEach((value) => {
    var pro_id = parseInt(value.getAttribute('data-productid'));
    
    if(pro_id !== undefined && pro_id !== null && pro_id !="" && value.getAttribute("data-pro-type")=="subscription") {
      pro_id = parseInt(pro_id);
        // window.ReChargeWidget.createWidget({ productId: pro_id });
        const config = {
        productId: pro_id,
        injectionParent: value,
        injectionMethod: 'prepend' // How will the widget be injected 
      };
      window.ReChargeWidget.createWidget(config);
    };
  });
}
function createWidgetNew(){
    try {
      createWidgetByCustomcode();
    } catch( ex ) {
        setTimeout(function(){
          createWidgetNew();
       },500)
    }
}
document.addEventListener("DOMContentLoaded", () => {
  createWidgetNew();
});


// menu drawer trigger click event
var menu_drawer = document.querySelector('.header_close_icon .icon-close');
var trriger_click = document.querySelector('.header__icon--menu');

if(menu_drawer != null){
  menu_drawer.addEventListener('click',function(){
    trriger_click.dispatchEvent(new Event('click'));
  });
}


class GlobalVariable extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
    this.querySelector('.search-contact-page-field')?.addEventListener('keyup', this.onKeyUpSearchContent.bind(this));
  }

  bindEvents() {
    this.querySelectorAll('.main-faqs-tabbing').forEach((open_faq_content) =>
      open_faq_content?.addEventListener('click', this.onClickOpenFaq.bind(this))
    );
    this.querySelectorAll('.icon-arrow-left').forEach((close_faq_content) =>
      close_faq_content?.addEventListener('click', this.onClickCloseFaq.bind(this))
    );
    this.querySelectorAll('.faq-popup-content').forEach((open_popup_content) =>
      open_popup_content?.addEventListener('click', this.onClickOpenPopupContent.bind(this))
    );
    this.querySelectorAll('.contanct-faq-popup .popup-close-icon,.contanct-faq-popup .overlay').forEach((close_popup_content) =>
      close_popup_content?.addEventListener('click', this.onClickClosePopupContent.bind(this))
    );
    this.querySelectorAll('.discount-main-code-number .main-code-number').forEach((klaviyo_form_input) =>
      klaviyo_form_input?.addEventListener('click', this.inputKlaviyoForm.bind(this))
    );
    this.querySelectorAll('.help-inner .help-question').forEach((accordian_faq) =>
      accordian_faq?.addEventListener('click', this.OnClickAccordianFaq.bind(this))
    );
    this.querySelectorAll('.scroll-smooth').forEach((scroll_smooth) =>
      scroll_smooth?.addEventListener('click', this.OnClickScrollToDiv.bind(this))
    );
    this.querySelectorAll('.main-account-tab-info li').forEach((open_account_tab) =>
      open_account_tab?.addEventListener('click', this.onClickOpenaAccountTap.bind(this))
    );
    this.querySelectorAll('.order-more-less a').forEach((open_order) =>
      open_order?.addEventListener('click', this.onClickOpenaOrder.bind(this))
    );
    this.querySelectorAll('.popup-code-sale').forEach((copy_code) =>
      copy_code?.addEventListener('click', this.onClickcopycode.bind(this))
    );
    this.querySelectorAll('.product-sale-popup .close-icon,.product-sale-popup .overlay').forEach((close_timer_popup) =>
      close_timer_popup?.addEventListener('click', this.onClickcloseaTimerPopup.bind(this))
    );
    this.querySelectorAll('.amz-02-popup-bottom-banner a').forEach((small_banner_popup) =>
      small_banner_popup?.addEventListener('click', this.onClicksamllBannerPopup.bind(this))
    );
    this.querySelectorAll('.banner-tab-content a').forEach((tab_content_all_product) =>
      tab_content_all_product?.addEventListener('click', this.onClickTabChange.bind(this))
    );
    this.querySelectorAll('.show-more').forEach((show_more) =>
      show_more?.addEventListener('click', this.onClickShowContent.bind(this))
    );
    this.querySelectorAll('.show-less').forEach((show_less) =>
      show_less?.addEventListener('click', this.onClickHideContent.bind(this))
    );
    this.querySelectorAll('.chapter-title-tab').forEach((video_content) =>
      video_content?.addEventListener('click', this.onClickVideoTab.bind(this))
    );
    this.querySelectorAll('.chapter-more-less').forEach((ChapterMoreLess) =>
      ChapterMoreLess?.addEventListener('click', this.onClickShowChapter.bind(this))
    );
    this.querySelectorAll('.per-month-kits-option input').forEach((perMonthKit) =>
      perMonthKit?.addEventListener('click', this.onClickSelectPerMonth.bind(this))
    );
    this.querySelectorAll('.amz-product-purchase input.custom-radio').forEach((perMonthPurchase) =>
      perMonthPurchase?.addEventListener('click', this.onClickSelectPurchaseKit.bind(this))
    );
    this.querySelectorAll('.code-container-sale').forEach((banner_copy_code) =>
      banner_copy_code?.addEventListener('click', this.onClickToCopyCode.bind(this))
    );
    this.querySelectorAll('.qna-btn a').forEach((qna_button) =>
      qna_button?.addEventListener('click', this.onClickOpenNextQue.bind(this))
    );
    this.querySelectorAll('.qna_checkbox_with_image input').forEach((qna_checkbox) =>
      qna_checkbox?.addEventListener('click', this.onClickQnaCheckboxWithImage.bind(this))
    );
    this.querySelectorAll('.qna_with_image .qna-btn-radio input').forEach((qna_with_image) =>
      qna_with_image?.addEventListener('click', this.onClickQnaWithImage.bind(this))
    );
    this.querySelectorAll('.qna_with_radiobtn .qna-checkbox-with-image input').forEach((qna_with_radiobtn) =>
      qna_with_radiobtn?.addEventListener('click', this.onClickQnaWithRadiobtn.bind(this))
    );
    this.querySelectorAll('.qna-btn-next-b .btn--calculate').forEach((qna_btn_calculate) =>
      qna_btn_calculate?.addEventListener('click', this.onClickQnaWithCalculateBtn.bind(this))
    );
    this.querySelectorAll('.question-btn a').forEach((question_button) =>
      question_button?.addEventListener('click', this.onClickOpenQuestion.bind(this))
    );
    this.querySelectorAll('.question-tabbing .tab-question').forEach((tab_question_button) =>
      tab_question_button?.addEventListener('click', this.onClickTabQuestion.bind(this))
    );
    this.querySelectorAll('.question2-step2 a').forEach((qna_step_2) =>
      qna_step_2?.addEventListener('click', this.onClickStep2Open.bind(this))
    );
    this.querySelectorAll('.custom-text-image-bg--customer-portal-image-with-text-block .featured-row__subtext a').forEach((show_Section) =>
      show_Section?.addEventListener('click', this.onClickShowHideSection.bind(this))
    );
  }
  
  onClickShowChapter(event){
    event.preventDefault();
    var __this = event.currentTarget;
    __this.closest('.main-video-section').querySelector('.main-chapter-tabbing').classList.toggle("more-less");
    if(__this.innerText=="Show More"){  
      __this.innerHTML = "Show Less";  
    }
    else{  
      __this.innerHTML = "Show More";  
    }
  }
  
  onClickShowContent(event){
    event.preventDefault();
    var __this = event.currentTarget;
    __this.closest('.chapter-description').classList.add("read-more-text");
  }

  onClickHideContent(event){
    event.preventDefault();
    var __this = event.currentTarget;
    __this.closest('.chapter-description').classList.remove("read-more-text");
  }

  onClickVideoTab(event){
    event.preventDefault();
    var __this = event.currentTarget;
    __this.getAttribute("class");
    var val = __this.getAttribute('data-href');
    var sec = __this.getAttribute('data-sec');
    var video_banner = document.querySelectorAll('.video-banner-image');
    for (var i = 0; i < video_banner.length; i++) {
      video_banner[i].style.display = "none";
    }
    var text_and_desc = document.querySelectorAll('.chapter-text-and-desc');
    for (var j = 0; j < text_and_desc.length; j++) {
      text_and_desc[j].classList.remove("active");
    }
    document.querySelector('#video').style.display = "block";
    document.querySelector('#'+val).classList.add("active");
    var myvideo = document.querySelector('#video');
    myvideo.play();
    myvideo.pause();
    myvideo.currentTime = sec;
    myvideo.play();
  }
  
  onKeyUpSearchContent(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    let searchString = __this.value;
    let input_val = searchString.toLowerCase();
    let searchMatchList = [];
    document.querySelector(".inline-search").innerHTML = "";
    if(input_val.length >=3){
      document.querySelector(".search-results").style.display = 'block';
      var faq_content = document.querySelectorAll('.help-content-main');
      var faq_content;
      for (var i = 0; i < faq_content.length; i++) {
        var helpinner = faq_content[i].querySelectorAll('.help-inner');
        for(var j = 0; j < helpinner.length; j++) {
          let blockId = helpinner[j].getAttribute('data-tab-id')
          let question = helpinner[j].querySelector('.help-question h4').innerText;
          let answer = helpinner[j].querySelector('.help-answer').innerText.trim();
          let matchdescription = answer.toLowerCase();
          let matchString = question.toLowerCase();
          let subdescriptionString
          if(matchdescription.indexOf(input_val)){
             subdescriptionString = matchdescription.substring(matchdescription.indexOf(input_val))  
          }
          else{
             subdescriptionString = matchdescription;
          }
          if(matchString.includes(input_val) || matchdescription.includes(input_val)){
             searchMatchList.push({title:question,id:blockId,description:answer,subdescription:subdescriptionString});
          }
        }
      }
      document.querySelector(".inline-search").innerHTML += ''
      for (var k = 0; k < searchMatchList.length; k++) {
        document.querySelector(".inline-search").innerHTML += '<li onclick="myFunction(this)" data-title-id="'+searchMatchList[k].id+'"><p>'+searchMatchList[k].title+'</p><p class="description">'+searchMatchList[k].description+'</p></li>';
      }
      if(searchMatchList.length == 1){
         document.querySelector(".inline-search li").style.borderBottom  = 'none';
      }
    }
    else{
      document.querySelector(".search-results").style.display = 'none';
    }
  }

  onClickOpenFaq(event) {
    var __this = event.currentTarget;
    var val = __this.getAttribute('data-name-val');
    var remoeClass_faq = document.querySelectorAll('.perticular-title-with-faqs');
    for (var i = 0; i < remoeClass_faq.length; i++) {
      remoeClass_faq[i].classList.remove('active-faq');
    }
    var addClass_faq = document.querySelectorAll('.contact-help-center');
    for (var i = 0; i < addClass_faq.length; i++) {
      if(typeof addClass_faq[i].querySelectorAll(`[data-faq-title="${val}"]`)[0] !== "undefined" ){
        addClass_faq[i].querySelectorAll(`[data-faq-title="${val}"]`)[0].classList.add('active-faq');
        addClass_faq[i].style.display = 'block';
        document.querySelector(".new-faqs-with-icons").style.display = 'none';
      }
    }
  }



  onClickOpenaAccountTap(event){
    var __this = event.currentTarget;
    var prev_li = __this.closest('ul').querySelectorAll('li');
    for (var i = 0; i < prev_li.length; i++) {
      prev_li[i].classList.remove('nav-active');
    }
    __this.classList.add('nav-active');
    var data_href = __this.querySelector('a').getAttribute('data-href');
    data_href = data_href.split("#");
    data_href = data_href[1];
    var tab_content = document.querySelectorAll('.account-tab-content');
    for (var i = 0; i < tab_content.length; i++) {
      tab_content[i].classList.remove('is-active');
      var search_attr = tab_content[i].getAttribute('id');
      if(search_attr == data_href){
        tab_content[i].classList.add('is-active');
      }
    }
  }

  onClickOpenaOrder(event){
     var __this = event.currentTarget;
     var table_row = __this.closest('.order-table').querySelectorAll('.latest-sort .table__section');
     for (var i = 0; i < table_row.length; i++) {
       if(i>4){
         if(table_row[i].classList.contains('hide')){
             table_row[i].classList.remove('hide');
             table_row[i].closest('.latest-sort').classList.add('more-less');
             __this.innerHTML = 'Show Less';
         }else{
             table_row[i].classList.add('hide');
             table_row[i].closest('.latest-sort').classList.remove('more-less');
             __this.innerHTML = 'Show More';
         }
       }
     }
  }
  
  onClickCloseFaq(event) {
    var __this = event.currentTarget;
    __this.closest('.perticular-title-with-faqs').classList.remove('active-faq');
    __this.closest('.contact-help-center').style.display = 'none';
    document.querySelectorAll('.new-faqs-with-icons')[0].style.display = 'block';
  }
  
  onClickOpenPopupContent(event) {
    var __this = event.currentTarget;
    var val = __this.getAttribute('data-name-val');
    var openPopup = document.querySelectorAll('.faq-popup-content');
    for (var i = 0; i < openPopup.length; i++) {
      if(typeof openPopup[i].querySelectorAll(`[data-popup-name="${val}"]`)[0] !== "undefined" ){
        openPopup[i].querySelectorAll(`[data-popup-name="${val}"]`)[0].classList.add('open-popup');
      }
    }
    document.body.classList.add('overflow-hidden');
  }
  
  onClickClosePopupContent(event) {
    var __this = event.currentTarget;
    __this.closest('.contanct-faq-popup').classList.remove('open-popup');
    document.body.classList.remove('overflow-hidden');
  }
  
  inputKlaviyoForm(event) {
    var __this = event.currentTarget;
    var val = __this.getAttribute('data-klaviyo');
    var remoeClass_input_discount = document.querySelectorAll('.main-code-number');
    for (var i = 0; i < remoeClass_input_discount.length; i++) {
      remoeClass_input_discount[i].classList.remove('nav-active');
    }
    __this.classList.add('nav-active');
    var remove_class_klaviyo = __this.closest('.discount-right-content').querySelectorAll('.klaviyo-email-send');
    for (var i = 0; i < remove_class_klaviyo.length; i++) {
      remove_class_klaviyo[i].classList.remove('active');
    }
    __this.closest('.discount-right-content').querySelectorAll(`[data-discount="${val}"]`)[0].classList.add('active');
  }

  OnClickAccordianFaq(event) {
    var __this = event.currentTarget;
    __this.closest('.help-inner').classList.toggle('active-inner')
  }
  
  OnClickScrollToDiv(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    var header_height = document.querySelector("sticky-header").offsetHeight;
    var scroll_hash = __this.getAttribute('href');
    var smooth_Scroll = document.querySelectorAll(scroll_hash)[0].getBoundingClientRect().top - header_height;
    if(document.querySelectorAll(scroll_hash)[0] !== "undefined") {
      window.scrollBy({
        top: smooth_Scroll,
        behavior: 'smooth'
      });
    }
  }

  onClickcopycode(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    __this.querySelector('input').focus();
    __this.querySelector('input').select()
    document.execCommand('copy');
    
    document.querySelectorAll(".popup-code-sale-copied")[0].classList.add('copiedd');
    document.querySelectorAll(".popup-code-sale-copied h2")[0].innerText= 'COPIED';
    setTimeout(function(){  
      document.querySelectorAll(".popup-code-sale-copied")[0].classList.remove('copiedd');
      document.querySelectorAll(".popup-code-sale-copied h2")[0].innerText= 'COPY CODE';
    }, 2000);
  }

  onClickcloseaTimerPopup(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    document.body.classList.remove('overflow-hidden');
    __this.closest('.product-sale-popup').classList.remove('open-popup');
    document.querySelectorAll('.amz-02-popup-bottom-banner')[0].style.display = 'block';
  }

  onClicksamllBannerPopup(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    document.body.classList.add('overflow-hidden');
    document.querySelector('.product-sale-popup').classList.add('open-popup');
    document.querySelector('.amz-02-popup-bottom-banner').style.display = 'none';
  }

  onClickTabChange(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    var val = __this.getAttribute('data-tabname');
    var nav_active_remove = document.querySelectorAll('.banner-tab-content a');
    for (var i = 0; i < nav_active_remove.length; i++) {
      nav_active_remove[i].classList.remove('nav-active');
    }
    __this.classList.add('nav-active');
    var removeCLass = document.querySelectorAll('.tabbing-products')
    for (var i = 0; i < removeCLass.length; i++) {
      removeCLass[i].classList.remove('active');
    }
    var tabbing_products = document.querySelectorAll('.all-product-sections');
    for (var i = 0; i < tabbing_products.length; i++) {
      if(typeof tabbing_products[i].querySelectorAll(`[data-attr="${val}"]`)[0] !== "undefined" ){
        tabbing_products[i].querySelectorAll(`[data-attr="${val}"]`)[0].classList.add('active');
      }
    }
    window.dispatchEvent(new Event('resize'));
  }

  onClickSelectPerMonth(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    var plan = __this.getAttribute('data-plan');
    var priceWithKits = __this.closest('.price-with-kits-permonth').querySelectorAll('.select-per-month-kits');
    for (var i = 0; i < priceWithKits.length; i++) {
      priceWithKits[i].classList.remove('nav-active');
    }
    var productDeliveryCycle = __this.closest('.product-delivery-cycle').querySelectorAll('.amz-product-purchase');
    for (var i = 0; i < productDeliveryCycle.length; i++) {
      productDeliveryCycle[i].classList.remove('active');
    }
    __this.parentNode.classList.add('nav-active');
    var productSelectKits  =__this.closest('.product-delivery-cycle').querySelectorAll(`[data-kit="${plan}"]`)
    for (var i = 0; i < productSelectKits.length; i++) {
      productSelectKits[i].classList.add('active');
    }

    setTimeout(function(){
      if (window.innerWidth > 1081) {
        var price = document.querySelectorAll('.desktop-view-1080 .amz-product-purchase.active')[0].querySelector(':checked').getAttribute('price');
      } else {
        var price = document.querySelectorAll('.mobile-view-1080 .amz-product-purchase.active')[0].querySelector(':checked').getAttribute('price');
      }  
      document.querySelectorAll('.price-with-kits-permonth')[0].querySelector('.pro_price p').innerHTML = price;
    },200);
  }

  onClickSelectPurchaseKit(event) {
    
    var __this = event.currentTarget;
    var select_val = __this.value;
    var price2 = __this.getAttribute('price');
    document.querySelectorAll('.price-with-kits-permonth')[0].querySelector('.pro_price p').innerHTML = price2;
    var productSelect = __this.closest('.amz-product-purchase').querySelectorAll('.pro-select-plan');
    for (var i = 0; i < productSelect.length; i++) {
      productSelect[i].classList.remove('select');
    }
    __this.closest('.amz-product-purchase').querySelectorAll(`[data-value="${select_val}"]`)[0].classList.add('select');
  }
  
  onClickToCopyCode(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    __this.querySelector('input').focus();
    __this.querySelector('input').select()
    document.execCommand('copy');
    
    if(__this.parentElement.querySelector('.coupen-code-btnText') != null){
      var code_btnText = __this.parentElement.querySelector('.coupen-code-btnText h2').getAttribute('btn-text');
      __this.parentElement.querySelector('.coupen-code-btnText h2').innerText = __this.querySelector('input').value;
      setTimeout(function(){  
         __this.parentElement.querySelector('.coupen-code-btnText h2').innerText = code_btnText;
       }, 2000);
    }else{
       __this.closest('global-variable').querySelectorAll(".code-container-sale-copied")[0].classList.add('copiedd');
        __this.closest('global-variable').querySelectorAll(".code-container-sale-copied h2")[0].innerText= 'COPIED';
       setTimeout(function(){  
         __this.closest('global-variable').querySelectorAll(".code-container-sale-copied")[0].classList.remove('copiedd');
         __this.closest('global-variable').querySelectorAll(".code-container-sale-copied h2")[0].innerText= 'COPY CODE';
       }, 2000);
    }
  }

  onClickOpenNextQue(event) {
    var __this = event.currentTarget;
    var question_element = document.querySelectorAll('.qna-one');
    for (var i = 0; i < question_element.length; i++) {
      question_element[i].classList.remove('active');
    }
    __this.closest('.qna-one').nextSibling.nextElementSibling.classList.add('active');
  }
  onClickQnaCheckboxWithImage(event) {
    var __this = event.currentTarget;
    if(__this.checked == true) {
      var checkbox_content = document.querySelectorAll('.checkbox_content');
      for (var i = 0; i < checkbox_content.length; i++) {
        checkbox_content[i].classList.remove('open');
      }
      __this.closest('label').nextSibling.nextElementSibling.classList.add('open');
    } else {
      __this.closest('label').nextSibling.nextElementSibling.classList.remove('open');
    }
  }
  
  onClickQnaWithImage(event) {
    var __this = event.currentTarget;
    var _true = document.getElementById("true");
    var _false = document.getElementById("false");
    if (_true.checked == true || _false.checked == true ) {
      __this.closest('.qna-main-section').classList.add('show-content');
    } else {
      __this.closest('.qna-main-section').classList.remove('show-content');
    }
  }
  
  onClickQnaWithRadiobtn(event) {
    var __this = event.currentTarget;
    if(__this.checked == true) {
      var radio_btn_select = document.querySelectorAll('.qna_with_radiobtn')[0].querySelectorAll('.qna-checkbox-with-image');
      for (var i = 0; i < radio_btn_select.length; i++) {
        radio_btn_select[i].classList.remove('active');
      }
      __this.closest('.qna-checkbox-with-image').classList.add('active');
    }
    var val = __this.getAttribute('data-price');
    var width = __this.getAttribute('data-width');
    var title = __this.getAttribute('data-title');
    $(this).prop('Counter',0).animate({
      Counter: val
    }, {
      duration: 1000,
      easing: 'swing',
      step: function (val) {
        document.querySelector('.per-year-price-cost .cost-price').innerText = (Math.ceil(val));
      }
    });
    document.querySelector('.per-year-price-cost .cost-price').innerText = val;
    document.querySelector('.sub-guidance-1 p').innerText = title;
    document.querySelector('.qna_with_radiobtn .progress-bar').style.transition = "unset";
    document.querySelector('.qna_with_radiobtn .progress-bar').style.width = 0;
    document.querySelector('.qna_with_radiobtn .progress-bar').style.opacity = 0;
    setTimeout(function(){
      document.querySelector('.qna_with_radiobtn .progress-bar').style.transition = "width 1s ease";
      document.querySelector('.qna_with_radiobtn .progress-bar').style.width = width;
      document.querySelector('.qna_with_radiobtn .progress-bar').style.opacity = 1;
    },100);
  }
  onClickQnaWithCalculateBtn(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    var val = __this.closest('.qna-main-section').querySelectorAll('input[name="option"]:checked')[0].getAttribute('data-saveprice');
    var title = __this.closest('.qna-main-section').querySelectorAll('input[name="option"]:checked')[0].getAttribute('data-title');
    $(this).prop('Counter',0).animate({
      Counter: val
    }, {
      duration: 1000,
      easing: 'linear',
      step: function (val) {
        document.querySelector('.saving-money-box .saving-money').innerText = (Math.ceil(val));
      }
    });
    __this.closest('.qna-main-section').style.display = 'none';
    __this.closest('.qna-main-section').nextSibling.nextElementSibling.style.display = 'block';
    document.querySelector('.saving-money-box .saving-money').innerText = val;
    document.querySelector('.treatment-text').innerText = title;
    
    setTimeout(function(){
      document.querySelector('.bar-for-treatment-saving').style.transition = "width 1s ease";
      document.querySelector('.bar-for-treatment-saving').style.width = '100%';
      document.querySelector('.bar-for-treatment-cost').style.transition = "width 1s ease";
      document.querySelector('.bar-for-treatment-cost').style.width = '20px';
    },100);
  }

  onClickOpenQuestion(event) {
    var __this = event.currentTarget;
    var _question_one = document.querySelectorAll('.question-one');
    for (var i = 0; i < _question_one.length; i++) {
      _question_one[i].classList.remove('active');
    }
    __this.closest('.question-one').nextSibling.nextElementSibling.classList.add('active');
  }

  onClickTabQuestion(event) {
    event.preventDefault();
    var __this = event.currentTarget;
    var val = __this.getAttribute('href');
    var tab_qna = __this.closest('.question-one').querySelectorAll('.tab-question');
    for (var i = 0; i < tab_qna.length; i++) {
      tab_qna[i].classList.remove('nav-active');
    }
    var qna_ans = __this.closest('.question-one').querySelectorAll('.question-to-answer');
    for (var i = 0; i < qna_ans.length; i++) {
      qna_ans[i].classList.remove('active');
    }
    var select_option_product = __this.closest('.question-one').querySelectorAll('.select-option-product');
    if(select_option_product.length > 0) {
      for (var i = 0; i < select_option_product.length; i++) {
        select_option_product[i].classList.remove('active');
      }
    }
    __this.classList.add('nav-active');
    __this.closest('.question-one').querySelector(val).classList.add('active');
    __this.closest('.question-one').querySelector('.question2-step2').style.display = 'block';
  }

  onClickStep2Open(event) {
    var __this = event.currentTarget;
    var val = __this.getAttribute('href');
    __this.closest('.qna_with_img_and_text').querySelector('.question-2-step').style.display = 'none';
    document.querySelector(val).style.display = 'block';
  }
  
  onClickShowHideSection(event) {
     event.preventDefault();
    var __this = event.currentTarget;
    __this.closest('.custom-text-image-bg--customer-portal-image-with-text-block').classList.toggle('show-bottom-section');
  }

  
}
customElements.define('global-variable', GlobalVariable);

function myFunction(event) {
  var __this = event;
  var header_height = document.querySelector("header").offsetHeight;
  var targerScroll = __this.getAttribute('data-title-id');
  document.querySelector(".new-faqs-with-icons").style.display = 'none';
  var main_faq__hide_div = document.querySelectorAll(".faqs-main-show");
  for (var i = 0; i < main_faq__hide_div.length; i++) {
    main_faq__hide_div[i].style.display = 'none';
  }
  var faq_remove_class = document.querySelectorAll('.perticular-title-with-faqs');
  for (var i = 0; i < faq_remove_class.length; i++) {
    faq_remove_class[i].classList.remove('active-faq');
  }
  var faq_que_class_remove = document.querySelectorAll('.help-inner');
  for (var i = 0; i < faq_que_class_remove.length; i++) {
    faq_que_class_remove[i].classList.remove('active-inner');
  }
  var faq_content = document.querySelectorAll('.help-content-main');
  var faq_content;
  for (var i = 0; i < faq_content.length; i++) {
    if(typeof faq_content[i].querySelectorAll('[data-tab-id="'+targerScroll+'"]')[0] !== "undefined" ){
      var match_faq = faq_content[i].querySelectorAll('[data-tab-id="'+targerScroll+'"]')[0];
      match_faq.closest('.perticular-title-with-faqs').classList.add('active-faq');
      match_faq.closest(".faqs-main-show").style.display = 'block';
      match_faq.querySelector('.help-question').dispatchEvent(new Event('click'));
      setTimeout(function(){
        var scrollval = match_faq.getBoundingClientRect().top - header_height;
        document.querySelector('.search-contact-page-field').value = '';
        document.querySelector('.search-results').style.display = 'none';
        window.scrollBy({
          top: scrollval,
          behavior: 'smooth'
        });
      },500);
    }
  }
}

setTimeout( function(){
  var judgme_review = document.querySelectorAll('.jdgm-rev__buyer-badge-wrapper');
  for (var i = 0; i < judgme_review.length; i++) {
    judgme_review[i].innerHTML = '<span class="jdgm-rev__buyer-badge-wrapper">  <span class="jdgm-rev__buyer-badge"></span>  </span>';
  }
}  , 2000 );


// window scroll events
window.onscroll = function () {

  // amz-lp-01 and amz-lp-shampoo page
  if (document.querySelector('.add-to-cart-btn')) {
    var top_of_element = document.querySelector(".main-product-sunscription").offsetTop;
    var bottom_of_element = document.querySelector(".main-product-sunscription").offsetTop + document.querySelector(".main-product-sunscription").offsetHeight;
    var bottom_of_screen = window.pageYOffset + window.innerHeight;
    var top_of_screen = window.pageYOffset;
    
    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        document.querySelector('.add-to-cart-btn').classList.add('hide');
    } else {
        document.querySelector('.add-to-cart-btn').classList.remove('hide');
    }
  }

  if(document.querySelector('.banner-tab-content') !== null){
    var height = document.querySelector('.banner-tab-content').offsetHeight;
  }
  if(document.querySelector("sticky-header") !== null){
    var header_height = document.querySelector("sticky-header").offsetHeight;
  }
  if (window.innerWidth > 769) {
    var scroll = 900;
    var sticky_banner_height = header_height+100;
  }else {
    var scroll = 1150;
    var sticky_banner_height = header_height;
  }
  if (document.documentElement.scrollTop >= scroll){
    if(document.querySelector(".banner-tab-content") !== null){
      document.querySelector(".banner-tab-content").classList.add('banner_sticky');
      setTimeout(function(){
        document.querySelector(".banner-tab-content").classList.add('banner_sticky--opening');
      },100);
      document.querySelector(".banner-tab-content").style.top = header_height+"px";
    }
    if(document.querySelector('.product-banner-sticky') !== null){
      document.querySelector('.product-banner-sticky').style.paddingTop = height+"px";
    }
  }
  else {
    if(document.querySelector(".banner-tab-content") !== null){
      document.querySelector(".banner-tab-content").classList.remove('banner_sticky');
      document.querySelector(".banner-tab-content").classList.remove('banner_sticky--opening');
      document.querySelector(".banner-tab-content").style.top = "0px";
    }
    if(document.querySelector('.product-banner-sticky') !== null){
      document.querySelector('.product-banner-sticky').style.paddingTop = "0px";
    }
  }
  var sticky_header = document.querySelector("sticky-header");
  var sticky_content = document.querySelector(".banner-with-share-link");
  if(sticky_header !== null){
    if(sticky_content !== null){
      document.querySelector(".banner-with-share-link").style.top = sticky_banner_height+"px";
    }
  }
};


////////////////// direct checkout form

var checkout_form = document.querySelectorAll(".checkout--form");
for(var i=0; i<checkout_form.length; i++){
  checkout_form[i].addEventListener("submit", function(e){
    e.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    
    const formData = new FormData(this);
    config.body = formData;
    fetch('/cart/clear.js')
      .then((response) => response.json())
      .then((response) => {
        
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {       
         fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {       
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
          submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
          window.location = "/checkout";
        });
      });
  });
}


/////////////// add to cart bundle products 

var bundle__click = document.querySelectorAll(".product-bundle-click");
values = [];
for(var i=0; i<bundle__click.length; i++){
  bundle__click[i].addEventListener("click", function(e){
    e.preventDefault();
    this.setAttribute('aria-disabled', true);
    this.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    var bundle_var_id = this.closest('.subscription-form').querySelectorAll(".product-select");
    for (var i = 0; i < bundle_var_id.length; i++) {
      var pro_val = bundle_var_id[i].querySelector('input').value;
      values.push({id: pro_val,quantity: 1});
    }
    let formData = {items: values}
    fetch('/cart/clear.js')
    .then((response) => response.json())
    .then((response) => {
      
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {       
       fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        
        this.removeAttribute('aria-disabled');
        this.classList.remove('loading');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        window.location = "/checkout";
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  });
}

var checkout_form = document.querySelectorAll(".checkout-with-add-free-product");
for(var i=0; i<checkout_form.length; i++){
  checkout_form[i].addEventListener("submit", function(e){
    e.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    
    const formData = new FormData(this);
    config.body = formData;
    fetch('/cart/clear.js')
      .then((response) => response.json())
      .then((response) => {
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {       
         fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {    
          if(this.closest('.pop-pro-atc').querySelectorAll('.add-free-product').length > 0 ){
            var vid = parseInt(this.closest('.pop-pro-atc').querySelectorAll('.add-free-product')[0].getAttribute('data-id'));
            var qty = parseInt(this.closest('.pop-pro-atc').querySelectorAll('.add-free-product')[0].getAttribute('data-quantity'));
  
            let formData2 = {
             'items': [{
              'id': vid,
              'quantity': qty
              }]
            };
  
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData2)
            })
            .then(response => {
              
              submitButton.removeAttribute('aria-disabled');
              submitButton.classList.remove('loading');
              submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
              window.location.href = "/discount/MIFREE?redirect=/checkout";
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          } else {
              submitButton.removeAttribute('aria-disabled');
              submitButton.classList.remove('loading');
              submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
              window.location = "/checkout";
          }
        });
      });
  });
}


/////////////// swap product for customer portal page
var checkout_form = document.querySelectorAll(".swap_product_form");
for(var i=0; i<checkout_form.length; i++){
  checkout_form[i].addEventListener("submit", function(e){
    e.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var swap_id = this.querySelector('.add-to-cart-with-swap').getAttribute('data-swap');
    const formData = new FormData(this);
    if(swap_id == 'true') {
      formData.append('properties[swap]', 'product');
      config.body = new URLSearchParams(formData);
    } else {
      config.body = formData;
    }
    
    fetch('/cart/clear.js')
      .then((response) => response.json())
      .then((response) => {
        
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {       
         fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {       
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
          submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
          window.location = "/checkout";
        });
      });
  });
}

// survey url pass with # to active question

var arr = window.location.href.split('/');
var parameter = arr[arr.length-1].split('#');
window.dispatchEvent(new Event('resize'));
if(typeof parameter[1] !== 'undefined' && parameter[1] !== null ){
  var deActive_section = document.querySelectorAll('.qna-one');
  if(deActive_section !== null){
    for (var i = 0; i < deActive_section.length; i++) {
      deActive_section[i].classList.remove('active');
    }
  }
  var deActive_section2 = document.querySelectorAll('.question-one');
  if(deActive_section2 !== null){
    for (var i = 0; i < deActive_section2.length; i++) {
      deActive_section2[i].classList.remove('active');
    }
  }
  document.getElementById(parameter[1]).classList.add('active');
}